<button type="button"
  class="btn"
  (click)="toggle()"
  [disabled]="disabled">
  <i *ngIf="!check"
    class="far fa-square fa-2x"></i>
  <i *ngIf="check"
    class="fa fa-check-square text-primary fa-2x"></i>
</button>
